const TermsEn = () => {
  return (
    <div className="py-12 text-gray-600">
      <div className="max-w-3xl mx-auto px-4 space-y-8">
        <h1 className="text-3xl font-bold">[She App. terms and conditions]</h1>

        <p>
          1. Acceptance of terms
          <br />
          Please read this Agreement. By creating an account, accessing or using
          the App, you acknowledge that you agree to and accept the terms of
          this Agreement. If you do not agree to these Terms, you may not access
          or use the App.
        </p>

        <p>
          We may amend this Agreement from time to time. If we make any
          modifications to materially change your rights, we will notify you by
          email or app, or present a revised version of the Agreement for you to
          accept. If you continue to use the App after the effective date of the
          updated version of the Agreement, you will be deemed to have accepted
          the amended Agreement.
        </p>

        <p>
          2. Medical Services Disclaimer
          <br />
          Our company are not a medical licensed health care provider, and the
          purpose of this app is not to replace professional medical advice,
          diagnosis, treatment, or management of diseases or medical symptoms,
          nor to provide birth control methods, or contraception methods.
          Consult a licensed doctor or other qualified health care provider
          before making or taking any decision or action that may affect your
          health or safety or your family or fetus. You should not ignore
          professional medical advice although you have read something about
          this app and you should not delay seeking professional medical advice.
          If you have any questions or concerns about your health and symptoms,
          or if you have any changes in your symptoms or health condition, be
          sure to consult a medical professional. If you believe it to be a
          medical emergency, call 911 immediately or go to your nearest
          emergency room.
        </p>

        <p>
          We are not responsible for any mistakes, omissions or unintended
          technical errors, or typos in the materials provided. And we are not
          responsible for any violations of your social ethics and moral
          standards regarding sex education and sex education materials.
        </p>

        <p>
          3.Registration and Eligibility
          <br />
          To use the App, you may need to create or update an account
          (&quot;Account&quot; same as below). And you may be required to
          provide some personal information, such as your name, gender, date of
          birth, and email address. This information will be maintained and used
          in accordance with our Privacy Policy. Our privacy policy can be found
          at (Menu-&gt;Privacy Policy). You agree to provide us with accurate
          and complete information and to update that information promptly if
          the information changes.
        </p>

        <p>
          <br />
          4. Using the app
          <br />
          All content you provide through the App is managed in accordance with
          our Privacy Policy. If there is a discrepancy between this Agreement
          and our Privacy policy, these Terms will prevail. If you submit a
          question or response, you are solely responsible for the content of
          your communication, the reliability of the communication found in the
          public domain as a result of the publication of the communication. The
          company and its licensors are not responsible for the consequences of
          communication in the public domain. As a condition of your use of the
          App, you agree that you will not use the App for any purpose
          prohibited by this Agreement. You are responsible for all your actions
          related to the App. You must comply with all local, state, national,
          and international laws and regulations and all applicable regulatory
          laws. If you do any of the following, you will substantially violate
          this Agreement. You agree not to do as follows:
        </p>

        <p>
          a. Resale, lease, rent, loan, license transfer, distribution, or
          transfer of other app rights.
        </p>

        <p>
          b. Modify apps, reverse design apps, decompile apps, or disassemble
          apps.
        </p>

        <p>
          c. Copy, transform, change, modify, translate, or create app
          derivations without our written permission.
        </p>

        <p>
          d. Authorize others to use the App, including (but not limited to)
          sharing the use of the app to others through a network connection, in
          any way other than as set forth in these Terms.
        </p>

        <p>
          e. Circumvent or disable the technical features or measures of the app
          to protect intellectual property rights.
        </p>

        <p>
          f. Use or attempt to use a device, program, or service designed to
          circumvent the rights protected by the copyright laws of any
          jurisdiction and technical measures are taken to control access to
          content files and other works in connection with the App
        </p>

        <p>
          g. Access or use our app to compile data to enable or make available
          competing products or services
        </p>

        <p>
          Your license to use the app will be terminated if you perform the
          above prohibited acts.
        </p>

        <p>
          <br />
          5. Limited license of the app
          <br />
          We grant you a personal, worldwide, revocable, non-transferable,
          non-exclusive license to access and use the App for your personal,
          non-commercial purposes in accordance with the terms of this
          Agreement.
        </p>

        <p>
          All rights, qualifications, and interests that are not definitely
          granted to the App in this Agreement are reserved by the Company. If
          you wish to use any identity associated with our software,
          qualifications, trade names, trademarks, service marks, logos, domain
          names, and/or any other distinct brand feature or other content owned
          by us, you must obtain our written permission. Permit requests can be
          sent to marketing@philmedi.com.
        </p>

        <p>
          For the avoidance of doubt, we own all text, images, photos and all
          data formats and communication formats that we create and provide in
          connection with the App. Our possession includes (but is not limited
          to) the visual interface, graphics, design, user content collection
          material, user rating ranking material collection, and all other
          elements and components of the App. Except as expressly and clearly
          stated herein, we do not grant you any express or implied rights in or
          relating to the App, and all rights to the App and Company content are
          reserved by us.
        </p>

        <p>
          6. If you use it, you take risks&nbsp;
          <br />
          Our company goal is to make certain health-related information easier
          and more useful for users. However, the App cannot and does not
          guarantee health-related improvements or health-related results. Your
          use of the App, and the risk you may incur when you use any
          information, period prediction, or other suggestions presented by the
          app, is entirely your responsibility. We make no representations or
          warranties of any kind regarding the accuracy of the data,
          information, guesses, or predictions that we provide to you through
          the App. And you agree that the app is not designed to match the
          purpose of a medical scientific device or to serve that purpose.
        </p>

        <p>
          7. Password
          <br />
          You are responsible for taking significant steps to prevent
          unauthorized people from accessing your app password or account. You
          are solely responsible for: (1) Controlling the dissemination and use
          of the applicant&#39;s name, controlling the dissemination and use of
          the screen name and password (2) Controlling access to your App
          account and password and use to authorize, monitor them (3) If your
          account or password has been compromised, or if you have a compelling
          reason to deactivate your password, please send us email
          marketing@philmedi.com to promptly notify us. You grant the right to
          transmit, monitor, retrieve, store, and use your information related
          to the operation of the App to any company, any relevant individual,
          or entity involved in the operation of the App. The Company cannot and
          shall not be liable for any information you submit. The same applies
          to the use or misuse of information sent or received by you or a third
          party using the app.
        </p>

        <p>
          8. Warranty Disclaimer
          <br />
          The company controls and operates the app in various regions, but this
          does not mean that the app is appropriate and available in all
          regions. The app or app characteristics may not be available depending
          on the region, and may vary.
        </p>

        <p>
          Our app is provided &quot;as current&quot; and &quot;as currently
          available&quot;. It is provided without warranty or indication of any
          kind, including (but not limited to) warranties that are implied by
          eligibility, non-legal violations, merchant ability, fitness for a
          particular purpose, and the course of performance or trade custom.
          Except to the extent required by law separately, all indications and
          warranties are clearly indemnified.
        </p>

        <p>
          Our company, our company&rsquo;s managers, employees, agents,
          representatives, suppliers, subcontractors and content providers do
          not warrant that: (A) The app will be safe and available at all
          specific times and locations. (B) All defects or errors will be
          corrected. (C) All content obtained through the app or app is
          virus-free and has no harmful components. (D) The results of using the
          app will meet your requirements. The risk of using the app is entirely
          your responsibility. or (E) You are responsible for the accuracy,
          reliability, or completeness of any context, text, images, software,
          graphics, or communications provided by secret chats and apps or to
          third parties through the app. Some states and countries do not allow
          restrictions on implied warranties, so the above restrictions may not
          apply to you.
        </p>

        <p>
          9. Restriction
          <br />
          Neither our company nor our representatives, custodians, agents,
          affiliates, employees, advertisers, or data providers shall be liable
          for any indirect, special, incidental, indirect, punitive, or
          consequential damages (including loss of use, loss of profit, loss of
          data, etc.) under any circumstances. This applies in the case of
          damages arising out of the performance of a contract, tort (including
          negligence, etc.), equity, or any other matter arising out of or in
          connection with the use of the App. In no event shall the
          company&#39;s entire liability arising out of these terms or these
          terms, or the company&#39;s celestial liability arising out of the use
          of the App or the inability to use the App, exceed one hundred dollars
          ($100) if you pay the Company for the use of the App, or if you are
          not obliged to pay the Company for the use of the App. Some
          jurisdictions do not allow the exclusion or limitation of liability.
          In this case, the above restrictions may not apply to you. We or any
          third party described in the App are not responsible for personal
          injury (including death) caused by your use or misuse of the App.
        </p>

        <p>
          10. Using a mobile device
          <br />
          If you use the app through a mobile device, keep in mind that your
          carrier&#39;s &nbsp;general charges and fees (such as text charges and
          data charges) may apply.
        </p>

        <p>
          11. Your Reviews
          <br />
          We welcome your app reviews. Unless clearly stated otherwise, any
          content you send to us or post to the App Store is considered
          non-confidential. You agree that we may disclose such content at our
          discretion. You agree that we authorize you to use, revise, modify,
          adjust, change the context, or change your content in a manner that we
          deem appropriate, at no cost.
        </p>

        <p>
          12. Enforcement Rights
          <br />
          We have no obligation to monitor access to the app or use of the app.
          However, we reserve the right to do so for the purpose of operating
          and maintaining the App, complying with this Agreement, and abiding by
          applicable legal requirements. We may disclose illegal activities to
          law enforcement authorities. In accordance with reasonable legal
          process, we may work with law enforcement authorities to prosecute
          users who violate the law. If we determine in our sole discretion that
          your use of the Content or App is contrary to this Agreement or in
          violation of this Agreement, we reserve the right to remove or disable
          access to all content and apps posted on the App at our sole
          discretion at any time without notice (this right is not mandatory).
          <br />
          The Company does not assume any responsibility or obligation to users
          of the App or other individuals or entities for performing or not
          performing the activities described above.
        </p>

        <p>
          13. App Changes
          <br />
          We may change, expand, or improve the App from time to time without
          prior notice to you. We may also suspend the operation of any part or
          all of the app at any time. Alternatively, you can selectively disable
          certain features of your app. By using the App, you do not have the
          right to require the continuous delivery and usability of the app. We
          may, in our absolute sole discretion, modify or remove the App or some
          features without any continuous obligation or liability to you.
        </p>

        <p>
          14. Rewards
          <br />
          You agree to defend, indemnify and hold the Company, its officers,
          directors, employees, agents, licensors, and suppliers harmless from
          and against all claims, actions, or demands, liabilities, and
          settlements, including reasonable legal accounting fees, arising out
          of or alleged to have arisen from your breach of this Agreement.
        </p>

        <p>
          15. Other
          <br />
          Any reason for action you want to take in connection with your use of
          the app after the claim or reason for action occurs must be initiated
          within one year.
        </p>

        <p>
          If for any reason, the court of competent jurisdiction determines that
          the provisions of the Convention or any part thereof are
          unenforceable, the provisions shall be enforced to the maximum extent
          permitted to reflect the intent of this Convention as much as
          possible. The remaining provisions of the Convention are in effect.
          Printed copies of this Agreement may be allowed as evidence in
          judicial and administrative proceedings.
        </p>

        <p>
          By waiving any of the provisions set forth in this Agreement, the
          Company shall not consider it to mean further or continuous waiving of
          such or other provisions. The Company does not claim any rights or
          provisions under this Agreement, which does not constitute a waiver of
          the Company&#39;s rights or provisions. If for any reason a court of
          competent jurisdiction or other tribunal determines that any provision
          of this Agreement is invalid, illegal, or unenforceable, it shall be
          removed or limited to a minimum. The remaining provisions of the
          Convention are in effect.
        </p>

        <p>
          At the end of this Agreement, all provisions that must stay same due
          to their features will maintain without limitation after termination.
          The provisions contained herein are Title Provisions, Warranty
          disclaimers, and Limitation of Liability.
        </p>

        <p>
          All claims by the parties related to this Agreement will be conducted
          as individual litigation, and no claims will be consolidated or
          processed as a group unless the parties agree in advance in writing.
        </p>

        <p>
          We may refuse services, close accounts, and change eligibility
          requirements at any time.
        </p>

        <p>
          Questions and Comments
          <br />
          If you have any comments or questions to make regarding the details of
          the App or these Terms of Use, or if you need our assistance or have a
          claim to us, please contact marketing@philmedi.com.
        </p>
      </div>
    </div>
  );
};
export default TermsEn;
